<template>
    <v-dialog v-model="openMode" max-width="500px">
      <v-card class="permissions-dialog">
        <v-card-title class="dialog-header">
          <v-icon left class="ml-2" dark>mdi-shield-account</v-icon>
          הרשאות
        </v-card-title>
  
        <v-card-text>
          <v-container class="permissions-container">
            <v-card outlined class="permissions-card">
              <v-card-title class="permissions-title">
                <v-icon color="#0d2c6d" class="ml-2">mdi-key</v-icon>
                הגדרות הרשאות
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="permissionsToEdit.confRoom"
                      color="#0d2c6d"
                      hide-details
                      class="permission-checkbox"
                    >
                      <template v-slot:label>
                        <div class="permission-label">
                          <v-icon small color="#0d2c6d" class="ml-2">mdi-account-group</v-icon>
                          חדר ועידה
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="permissionsToEdit.playSubscribersNumbers"
                      color="#0d2c6d"
                      hide-details
                      class="permission-checkbox"
                    >
                      <template v-slot:label>
                        <div class="permission-label">
                          <v-icon small color="#0d2c6d" class="ml-2">mdi-playlist-play</v-icon>
                          השמעת פרטי החברים בקבוצה
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>
  
        <v-divider></v-divider>
  
        <v-card-actions class="dialog-actions">
          <v-btn
            color="primary"
            class="save-button"
            @click="saveChanges"
            :loading="progressShow"
            :disabled="progressShow"
          >
            <v-icon left>mdi-content-save</v-icon>
            שמור שינויים
          </v-btn>
          <v-btn
            color="grey lighten-3"
            
            @click="closeDelete"
          >
            סגור
          </v-btn>
        </v-card-actions>
      </v-card>
  
      <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-dialog>
  </template>
    
  <script>
  import ApiServices from '@/services/api.service'
  import SnackBar from '@/components/widgets/snackBar.vue'
  
  export default {
    props: {
      ivr: Object,
      value: { type: Boolean, default: false },
    },
    components: {
      SnackBar,
    },
    data: () => ({
      progressShow: false,
      snackbar: false,
      snackbarColorBt: "green",
      snacbarText: "",
      permissionsToEdit: {},
      sendCall: false,
    }),
  
    methods: {
      async saveChanges() {
        try {
          this.progressShow = true;
          let token = localStorage.getItem("token");
          const permissionsJSON = JSON.stringify({ 
            permissionsObj: this.permissionsToEdit, 
            ivrLineNumber: this.ivr.line_number
          });
  
          const api = process.env.VUE_APP_BASE_URL + "/agent_api/change_ivr_permissions";
          const res = await fetch(api, ApiServices.requestOptions("POST", permissionsJSON, token));
          const jsonObject = await res.json();
          if (res.status >= 400) {
            this.showSnackBar("שגיאה בשמירת ההרשאות ", "red");
            this.progressShow = false;
          } else if (res.status === 200) {
            this.progressShow = false;
            this.$emit("ivrPermissionsChanged", this.permissionsToEdit);
            this.showSnackBar("השינויים נשמרו בהצלחה!", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("שגיאה בשמירת השינויים : " + error, "red");
        }
      },
      closeDelete() {
        this.openMode = false;
      },
      showSnackBar(message, color) {
        this.snacbarText = message;
        this.snackbarColorBt = color;
        this.snackbar = true;
      },
    },
    computed: {
      openMode: {
        get() {
          return this.value;
        },
        set(v) {
          return this.$emit('input', v);
        }
      },
    },
    mounted() {
      this.permissionsToEdit = { ...this.ivr.exten_permissions };
    },
  }
  </script>
  
  <style scoped>
  .permissions-dialog {
    border-radius: 12px;
    overflow: hidden;
    direction: rtl;
    font-family: 'Heebo', sans-serif;
  }
  
  .dialog-header {
    background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
    color: white;
    font-size: 1.5rem;
    font-weight: 600;
    padding: 16px;
  }
  
  .permissions-container {
    padding: 16px 0;
  }
  
  .permissions-card {
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  
  .permissions-card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .permissions-title {
    font-size: 16px;
    font-weight: 600;
    color: #0d2c6d;
    padding: 12px 16px;
    background-color: rgba(13, 44, 109, 0.05);
  }
  
  .permission-checkbox {
    margin-bottom: 8px;
  }
  
  .permission-label {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
  }
  
  .dialog-actions {
    padding: 16px;
    display: flex;
    justify-content: flex-start;
  }
  
  .save-button {
    background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
    color: #0d2c6d !important;
    font-weight: 600;
    margin-left: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  
  .save-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  
  /* Responsive adjustments */
  @media (max-width: 600px) {
    .dialog-actions {
      flex-direction: column;
    }
    
    .save-button {
      margin-left: 0;
      margin-bottom: 8px;
      width: 100%;
    }
  }
  </style>